export enum MutationKeys {
  CREATE_MAP = 'createMap',
  EDIT_MAP = 'editMap',
  DELETE_MAP = 'deleteMap',
  DELETE_LAYER = 'deleteLayer',
  GET_LAYER_BOUNDS = 'getLayerBounds',
  CREATE_DUPLICATE_LAYER = 'createDuplicateLayer',
  DOWNLOAD_LAYER = 'downloadLayer',
  DOWNLOAD_SELECTED_FEATURES = 'downloadSelectedFeatures',
  FETCH_FEATURES_FROM_LAYER = 'fetchFeaturesFromLayer',
  QUERY_MAP_FEATURES = 'queryMapFeatures',
  PROXIMITY_FEATURES = 'proximityFeatures',
  EDIT_FEATURES = 'editFeatures',
  EDIT_LAYER_OPTIONS = 'editLayerOptions',
  CREATE_LAYER_GROUP = 'createLayerGroup',
  RENAME_LAYER_GROUP = 'renameLayerGroup',
  UNGROUP_LAYER_GROUP = 'ungroupLayerGroup',
  REORDER_LEGEND = 'reorderLegend',
  CREATE_FILEMANAGER_FOLDER = 'createFilemanagerFolder',
  RESOLVE_DATASET_FOR_FILES = 'resolveDatasetForFiles',
  MOVE_FILEMANAGER_ITEMS = 'moveFilemanagerItems',
  EDIT_GEOSERVER_FEATURES = 'editGeoServerFeatures',
  UPDATE_FEATURE_TABLE_ROWS = 'updateFeatureTableRows',
  UPLOAD_FILE_TO_FOLDER = 'uploadFileToFolder',
  UPLOAD_FEATURES_TO_FOLDER = 'uploadFeaturesToFolder',
  CREATE_LAYER_FROM_GEOJSON = 'createLayerFromGeoJSON',
  CREATE_LAYER_FROM_FEATURES = 'createLayerFromFeatures',
  // Create Feature Tool (Sprint 4)
  CREATE_FEATURE_LAYER = 'createFeatureLayer',
  CREATE_FEATURE = 'createFeature',
  UPDATE_FEATURE = 'updateFeature',
  DELETE_FEATURE = 'deleteFeature',
  UPLOAD_FEATURE_ATTACHMENTS = 'uploadFeatureAttachments',
  CREATE_MAP_SKETCH = 'createMapSketch',
  EDIT_MAP_SKETCH = 'editMapSketch',
  DELETE_MAP_SKETCH = 'deleteMapSketch',
  ADD_SKETCH_ITEMS = 'addSketchItems',
  EDIT_SKETCH_ITEM = 'editSketchItem',
  DELETE_SKETCH_ITEM = 'deleteSketchItem',
  SAVE_SKETCH = 'saveSketch',
  GET_ICON_PRESIGNED_URL = 'getIconPresignedUrl',
  UPLOAD_ICON = 'uploadIcon',
  TOUCH_RECENT_ICON = 'touchRecentIcon',
  APPLY_DYNAMIC_STYLE = 'applyDynamicStyle',
  APPLY_UNIQUE_STYLE = 'applyUniqueStyle',
  APPLY_QUANTITY_STYLE = 'applyQuantityStyle',
  APPLY_HEATMAP_STYLE = 'applyHeatmapStyle',
  SAVE_FEATURE_TO_GEOSERVER = 'saveFeatureToGeoServer',
  CREATE_WMS_LAYER = 'createWmsLayer',
  UPDATE_PERMISSIONS = 'updatePermissions',
  SAVE_WORK_ORDERS = 'saveWorkOrders',
  UPDATE_WORK_ORDER_STATUS = 'updateWorkOrderStatus',
  UPDATE_WORK_ORDER = 'updateWorkOrder',
  CREATE_CONTACT = 'createContact',
  CREATE_GROUP = 'createGroup',
  UPDATE_CONTACT = 'updateContact',
  UPDATE_GROUP_NAME = 'updateGroupName',
  DELETE_CONTACT = 'deleteContact',
  DUPLICATE_CONTACT = 'duplicateContact',
  MOVE_CONTACT = 'moveContact',
  DELETE_GROUP = 'deleteGroup',
  //Auth
  AUTH_LOGIN = 'authLogin',
  AUTH_REQUEST_RESET = 'authRequestReset',
  AUTH_SET_PASSWORD = 'authSetPassword',
  AUTH_CANCEL_RESET = 'authCancelReset',
  VIEW_AS_CLIENT = 'viewAsClient',
  //Home
  UPDATE_DASHBOARD_SETTINGS = 'updateDashboardSettings',
  //My Profile
  EDIT_PROFILE = 'editProfile',
  SET_PROFILE_PASSWORD = 'setProfilePassword',
  REQUEST_SUBSCRIPTION_RENEWAL = 'requestSubscriptionRenewal',
  REQUEST_SUBSCRIPTION = 'requestSubscription',
  //Asset Manager
  SAVE_ASSET_LIST_CONFIG = 'saveAssetListConfig',
  SET_ASSET_LAYER_KEY_FIELD = 'setAssetLayerKeyField',
  //Asset Work Orders
  CREATE_ASSET_WORK_ORDER = 'createAssetWorkOrder',
  EDIT_ASSET_WORK_ORDER = 'editAssetWorkOrder',
  UPDATE_ASSET_WORK_ORDER_STATUS = 'updateWorkOrderStatus',
  SAVE_ASSET_WORK_ORDER_SETTINGS = 'saveAssetWorkOrderSettings',
  UPLOAD_ASSET_WORK_ORDER_ATTACHMENT = 'uploadAssetWorkOrderAttachment',
  DELETE_ASSET_WORK_ORDER = 'deleteAssetWorkOrder',
  DELETE_ASSET_WORK_ORDER_ATTACHMENT = 'deleteAssetWorkOrderAttachment',
  CREATE_ASSET_STATISTIC = 'createAssetStatistic',
  UPDATE_ASSET_STATISTIC = 'updateAssetStatistic',
  DELETE_ASSET_STATISTIC = 'deleteAssetStatistic',
}
